import { render } from "./CreateBatchAction.vue?vue&type=template&id=fa9180e4&scoped=true&ts=true"
import script from "./CreateBatchAction.vue?vue&type=script&lang=ts"
export * from "./CreateBatchAction.vue?vue&type=script&lang=ts"

import "./CreateBatchAction.vue?vue&type=style&index=0&id=fa9180e4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9180e4"]])

export default __exports__